"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[7288],{

/***/ 44690:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Desktop_Desktop)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/ada/SkipContent/SkipContent.tsx + 2 modules
var SkipContent = __webpack_require__(41124);
// EXTERNAL MODULE: ./src/compositions/LogoLink/LogoLink.tsx
var LogoLink = __webpack_require__(55988);
// EXTERNAL MODULE: ./src/compositions/Header/components/Banner/Banner.tsx + 42 modules
var Banner = __webpack_require__(82271);
// EXTERNAL MODULE: ./src/compositions/Header/components/MainHeader/MainHeader.tsx + 1 modules
var MainHeader = __webpack_require__(41612);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(39977);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/compositions/Header/components/ChatAssistance/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "birdie"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/ChatAssistance/ChatAssistance.tsx






const ChatAssistance = ()=>{
    const intl = (0,useIntl/* default */.Z)();
    const label = intl.formatMessage(messages.label);
    (0,react.useEffect)(()=>{
        void (0,manager/* preloadModal */.My)("chatAssistanceModal");
    }, []);
    const handleClick = ()=>{
        (0,manager/* openModal */.h7)("chatAssistanceModal");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "cursor-pointer text-white",
        type: "button",
        "aria-label": label,
        "data-testid": "ChatAssistance",
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "24/birdie"
        })
    });
};
/* harmony default export */ const ChatAssistance_ChatAssistance = (ChatAssistance);

// EXTERNAL MODULE: ./src/compositions/Header/components/QueueCounter/QueueCounter.tsx + 1 modules
var QueueCounter = __webpack_require__(35176);
// EXTERNAL MODULE: ./src/compositions/Header/components/Cart/Cart.tsx + 1 modules
var Cart = __webpack_require__(49854);
// EXTERNAL MODULE: ./src/compositions/Header/components/Search/Search.tsx + 1 modules
var Search = __webpack_require__(9667);
// EXTERNAL MODULE: ./src/compositions/Header/components/UserNavWrapper/UserNavWrapper.tsx
var UserNavWrapper = __webpack_require__(75715);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(36888);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/modules/user/referralProgram/index.ts
var referralProgram = __webpack_require__(21380);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
// EXTERNAL MODULE: ./src/compositions/navigation/NavItem/NavItem.tsx
var NavItem = __webpack_require__(23091);
// EXTERNAL MODULE: ./src/compositions/navigation/messages.ts
var navigation_messages = __webpack_require__(1867);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/SupNav/SupNav.tsx










const SupNav = ()=>{
    const { isLoggedIn } = (0,user/* useUser */.aF)();
    const { stats: { available } } = (0,referralProgram/* useReferralInvites */.n)();
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const isSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.isSubscribed;
    if (!isLoggedIn) {
        return null;
    }
    const getReferralLink = ()=>{
        const handleClick = ()=>{
            (0,analytics/* track */.j)("Banner click", {
                placement: "Header",
                content: "Referral program",
                action: "link",
                link: links/* default */.ZP.invite
            });
        };
        if (available) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                className: "flex items-center gap-8",
                to: links/* default */.ZP.invite,
                title: {
                    ...navigation_messages/* default */.Z.newReferral,
                    values: {
                        available,
                        freeFragranceClassName: "",
                        spanClassName: "bg-white text-black"
                    }
                },
                style: "p4",
                withArrow: true,
                onClick: handleClick
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gold-30 desktop:z-desktop-sup-header",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: "flex w-full items-center justify-between py-8",
            children: [
                getReferralLink(),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                            className: "inline-block",
                            style: "p4",
                            to: links/* default */.ZP.tracking,
                            title: navigation_messages/* default */.Z.track,
                            onClick: ()=>{
                                (0,analytics/* track */.j)("Track your order click", {
                                    placement: "Header"
                                });
                            }
                        }),
                        isSubscribed && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                            className: "ml-24 inline-block",
                            style: "p4",
                            to: links/* default */.ZP.queue,
                            title: navigation_messages/* default */.Z.queue,
                            onClick: ()=>{
                                (0,analytics/* track */.j)("Manage your queue click", {
                                    placement: "Header"
                                });
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const SupNav_SupNav = (SupNav);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/popover/popover.js + 6 modules
var popover = __webpack_require__(21864);
// EXTERNAL MODULE: ./local_modules/router/shared/hooks.ts
var hooks = __webpack_require__(91746);
// EXTERNAL MODULE: ./src/helpers/modifiers/sanitizeForAnalytics.ts
var sanitizeForAnalytics = __webpack_require__(91520);
// EXTERNAL MODULE: ./src/compositions/navigation/NavList/NavList.tsx
var NavList = __webpack_require__(20308);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/compositions/navigation/NavDivider/NavDivider.tsx



const NavDivider = (props)=>{
    const { className } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,clsx/* default */.Z)("border-solid-gray-80 desktop:h-32", className),
        role: "separator"
    });
};
/* harmony default export */ const NavDivider_NavDivider = (NavDivider);

// EXTERNAL MODULE: ./local_modules/links/getLinkWithParams.ts
var getLinkWithParams = __webpack_require__(66913);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(64667);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(80550);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var analytics_context = __webpack_require__(13210);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@growthbook+growthbook-react@0.23.0_react@18.2.0/node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(26853);
// EXTERNAL MODULE: ./src/modules/messages/messages.ts
var messages_messages = __webpack_require__(35000);
// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(29703);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTONavigationData.ts
var useStrapiWSTONavigationData = __webpack_require__(83474);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(88852);
// EXTERNAL MODULE: ./src/components/dataDisplay/ExclusiveLabel/ExclusiveLabel.tsx
var ExclusiveLabel = __webpack_require__(28259);
// EXTERNAL MODULE: ./src/compositions/Header/components/ReferralNavItem/ReferralNavItem.tsx
var ReferralNavItem = __webpack_require__(86653);
// EXTERNAL MODULE: ./src/compositions/Header/view/Desktop/components/banners/StrapiWSTONavigationBanner/StrapiWSTONavigationBanner.tsx
var StrapiWSTONavigationBanner = __webpack_require__(26458);
// EXTERNAL MODULE: ./src/modules/banners/useStrapiNavigationBanner.ts + 1 modules
var useStrapiNavigationBanner = __webpack_require__(89542);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(29564);
// EXTERNAL MODULE: ./src/compositions/banners/TheEditBanner/TheEditBanner.tsx + 3 modules
var TheEditBanner = __webpack_require__(68937);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var Button_messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/compositions/banners/BannerBase/BannerBase.tsx
var BannerBase = __webpack_require__(61835);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BrandsBanner/messages.ts
/* harmony default export */ const BrandsBanner_messages = ({
    perfumes: {
        title: {
            en: `
        Spotlight on:<br />
        <span class="text-gold-50">Skylar</span>
      `
        },
        text: {
            en: `
        Balancing perfumery with<br />
        hypoallergenic formulations,<br />
        Skylar proves that you can have<br />
        safe, clean scents that smell<br />
        utterly alluring.
      `
        }
    },
    colognes: {
        title: {
            en: `
        Spotlight on:<br />
        <span class="text-gold-50">Parfums De Marly</span>
      `
        },
        text: {
            en: `
        Crafted from a palette of noble<br />
        ingredients, Parfums de Marly<br />
        compositions are a meld of lavish<br />
        18th-century splendor, tailor-<br />
        made for the pure enjoyment.
      `
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BrandsBanner/images/perfumes.jpg
const perfumes_namespaceObject = __webpack_require__.p + "images/perfumes_8c0311.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BrandsBanner/images/colognes.jpg
const colognes_namespaceObject = __webpack_require__.p + "images/colognes_55e0ec.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BrandsBanner/BrandsBanner.tsx








const banners = {
    perfumes: {
        to: (0,getLinkWithParams/* default */.Z)(links/* default */.ZP.brand, {
            name: "skylar"
        }),
        bgImage: perfumes_namespaceObject,
        messages: BrandsBanner_messages.perfumes,
        brandName: "Skylar"
    },
    colognes: {
        to: (0,getLinkWithParams/* default */.Z)(links/* default */.ZP.brand, {
            name: "parfums-de-marly"
        }),
        bgImage: colognes_namespaceObject,
        messages: BrandsBanner_messages.colognes,
        brandName: "Parfums de Marly"
    }
};
const BrandsBanner = (param)=>{
    let { placement, onClick } = param;
    const { to, bgImage, messages, brandName } = banners[placement];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: to,
        title: messages.title,
        text: messages.text,
        textColor: "black",
        bgImage: bgImage,
        buttonTitle: Button_messages/* default */.Z.shopNow,
        content: "Featured brand",
        sizes: "560px",
        onClick: onClick,
        trackParams: {
            productBrand: brandName
        },
        "data-testid": "brandsBanner"
    });
};
/* harmony default export */ const BrandsBanner_BrandsBanner = (BrandsBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/QuizBanner/messages.ts
/* harmony default export */ const QuizBanner_messages = ({
    title: {
        en: "That scent is so you"
    },
    text: {
        en: "Learn about the fragrance\nfamilies you gravitate towards,\nand find scents that fit your\npreferences."
    },
    takeQuiz: {
        en: "Take the quiz"
    },
    retakeQuiz: {
        en: "Retake the quiz"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/QuizBanner/images/bg.jpg
const bg_namespaceObject = __webpack_require__.p + "images/bg_0e3bbc.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/QuizBanner/QuizBanner.tsx







const QuizBanner = (param)=>{
    let { onClick } = param;
    const { hasScentProfile } = (0,user/* useUser */.aF)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.smartRecommendations,
        title: QuizBanner_messages.title,
        text: QuizBanner_messages.text,
        bgImage: bg_namespaceObject,
        buttonTitle: hasScentProfile ? QuizBanner_messages.retakeQuiz : QuizBanner_messages.takeQuiz,
        content: "Quiz",
        sizes: "560px",
        onClick: onClick,
        "data-testid": "quizBanner"
    });
};
/* harmony default export */ const QuizBanner_QuizBanner = (QuizBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/GiftSubscriptionBanner/messages.ts
/* harmony default export */ const GiftSubscriptionBanner_messages = ({
    title: {
        en: "The gift that keeps\non giving"
    },
    text: {
        en: `
      With a Scentbird gift\nsubscription, your recipient\ncan take the lead and choose\nthe all fragrances
      they want\nto try for a three, six, or\ntwelve-month duration.
    `
    },
    buttonTitle: {
        en: "Shop gift subscriptions"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/GiftSubscriptionBanner/images/bg.jpg
const GiftSubscriptionBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_3ca901.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/GiftSubscriptionBanner/GiftSubscriptionBanner.tsx






const GiftSubscriptionBanner = (param)=>{
    let { onClick } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.giftSubscription,
        title: GiftSubscriptionBanner_messages.title,
        text: GiftSubscriptionBanner_messages.text,
        bgImage: GiftSubscriptionBanner_images_bg_namespaceObject,
        buttonTitle: GiftSubscriptionBanner_messages.buttonTitle,
        content: "Gift subscription",
        sizes: "560px",
        onClick: onClick,
        "data-testid": "giftSubscriptionBanner"
    });
};
/* harmony default export */ const GiftSubscriptionBanner_GiftSubscriptionBanner = (GiftSubscriptionBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CasesBanner/messages.ts
/* harmony default export */ const CasesBanner_messages = ({
    title: {
        en: "Pick a color,\nany color"
    },
    text: {
        en: "Available in a variety of hues, our\natomizer cases ensure your scent is\nalways dressed for the occasion."
    },
    buttonTitle: {
        en: "Shop cases"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CasesBanner/images/bg.jpg
const CasesBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_a37e52.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CasesBanner/CasesBanner.tsx






const CasesBanner = (param)=>{
    let { onClick } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.shop.scentbirdCases,
        title: CasesBanner_messages.title,
        titleColor: "white",
        text: CasesBanner_messages.text,
        textColor: "white",
        bgImage: CasesBanner_images_bg_namespaceObject,
        buttonTitle: CasesBanner_messages.buttonTitle,
        content: "Cases",
        sizes: "560px",
        onClick: onClick,
        "data-testid": "casesBanner"
    });
};
/* harmony default export */ const CasesBanner_CasesBanner = (CasesBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/DynamicNavigationBanner/DynamicNavigationBanner.tsx









const DynamicNavigationBanner = (props)=>{
    const { placement, onClick } = props;
    const isTheEditEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theEdit);
    const isStrapiBannersEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.strapiBanners);
    const { isFetching, bannerData } = (0,useStrapiNavigationBanner/* default */.Z)({
        placement,
        onClick,
        skip: !isStrapiBannersEnabled
    });
    const isTheValentinesEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theValentinesEdit) === "b";
    const isTheLuxeEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theLuxeEdit) === "b";
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
            className: "bg-light-beige",
            h: 296
        });
    }
    if (placement === "shop" && isTheEditEnabled && (isTheValentinesEditEnabled || isTheLuxeEditEnabled)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TheEditBanner/* default */.Z, {
            onClick: onClick
        });
    }
    if (!isStrapiBannersEnabled || !bannerData) {
        if (placement === "perfumes" || placement === "colognes") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandsBanner_BrandsBanner, {
                placement: placement,
                onClick: onClick
            });
        }
        if (placement === "discover") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizBanner_QuizBanner, {
                onClick: onClick
            });
        }
        if (placement === "gifts") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionBanner_GiftSubscriptionBanner, {
                onClick: onClick
            });
        }
        if (placement === "shop") {
            const BannerComponent = isTheEditEnabled ? TheEditBanner/* default */.Z : CasesBanner_CasesBanner;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerComponent, {
                onClick: onClick
            });
        }
        return null;
    }
    if (!bannerData) {
        return null;
    }
    const href = bannerData.isExternalLink ? bannerData.to : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: bannerData.to,
        href: href,
        bgImage: bannerData.bgImage,
        content: null,
        sizes: "560px",
        onClick: onClick,
        trackParams: bannerData.trackParams,
        "data-testid": "brandsBanner"
    });
};
/* harmony default export */ const DynamicNavigationBanner_DynamicNavigationBanner = (DynamicNavigationBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/DriftSubscriptionNavBanner/images/bg.jpg
const DriftSubscriptionNavBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_3b4a5c.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/DriftSubscriptionNavBanner/DriftSubscriptionNavBanner.tsx





const DriftSubscriptionNavBanner = (param)=>{
    let { onClick } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.driftSubscription,
        bgImage: DriftSubscriptionNavBanner_images_bg_namespaceObject,
        content: "Drift subscription",
        sizes: "560px",
        "data-testid": "driftSubscriptionNavBanner",
        onClick: onClick
    });
};
/* harmony default export */ const DriftSubscriptionNavBanner_DriftSubscriptionNavBanner = (DriftSubscriptionNavBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CandleSubscriptionBanner/messages.ts
/* harmony default export */ const CandleSubscriptionBanner_messages = ({
    title: {
        en: "Introducing our\nCandle Club"
    },
    text: {
        en: `
      Everything is illuminated, thanks to\nour luxe scented candles you'll\nreceive each month. Retailing at up\nto $75, these will light your fire.
    `
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CandleSubscriptionBanner/images/bg.jpg
const CandleSubscriptionBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_a79560.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CandleSubscriptionBanner/CandleSubscriptionBanner.tsx







const CandleSubscriptionBanner = (param)=>{
    let { onClick } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.candleSubscription,
        title: CandleSubscriptionBanner_messages.title,
        titleColor: "white",
        text: CandleSubscriptionBanner_messages.text,
        textColor: "white",
        bgImage: CandleSubscriptionBanner_images_bg_namespaceObject,
        buttonTitle: Button_messages/* default */.Z.learnMore,
        buttonStyle: "gold-30",
        content: "Candle subscription",
        sizes: "560px",
        onClick: onClick,
        "data-testid": "candleSubscriptionBanner"
    });
};
/* harmony default export */ const CandleSubscriptionBanner_CandleSubscriptionBanner = (CandleSubscriptionBanner);

// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(23450);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CaseSubscriptionBanner/messages.ts
/* harmony default export */ const CaseSubscriptionBanner_messages = ({
    title: {
        en: "Make a case for\nsomething new"
    },
    text: {
        en: `
      Month after month. Upgrade your\naccount to include a new atomizer\ncase
      in every order for an extra {price}\nper month, and ensure your scents\nare always covered.
    `
    },
    buttonTitle: {
        en: "Subscribe to monthly cases"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CaseSubscriptionBanner/images/bg.jpg
const CaseSubscriptionBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_cc3bcd.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CaseSubscriptionBanner/CaseSubscriptionBanner.tsx








const CaseSubscriptionBanner = (param)=>{
    let { onClick } = param;
    const { caseSubscription } = (0,subscriptionAddons/* useCaseSubscription */.PZ)();
    // fallback just in case of re-fetching
    const price = (0,formatPrice/* default */.Z)((caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.price) || 1000);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.caseSubscription,
        title: CaseSubscriptionBanner_messages.title,
        titleColor: "white",
        text: {
            ...CaseSubscriptionBanner_messages.text,
            values: {
                price
            }
        },
        textColor: "white",
        bgImage: CaseSubscriptionBanner_images_bg_namespaceObject,
        buttonTitle: CaseSubscriptionBanner_messages.buttonTitle,
        content: "Case subscription",
        sizes: "560px",
        onClick: onClick,
        "data-testid": "caseSubscriptionBanner"
    });
};
/* harmony default export */ const CaseSubscriptionBanner_CaseSubscriptionBanner = (CaseSubscriptionBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BuyQueueBanner/messages.ts
/* harmony default export */ const BuyQueueBanner_messages = ({
    title: {
        en: "Get more and then\nsave more"
    },
    text: {
        en: `
      Instead of waiting month after\nmonth, buy your entire queue\nand save on the lot.
      Unlock 5%\nwhen you add three items to\nyour cart, and 10% if you buy six.
    `
    },
    buttonTitle: {
        en: "Buy your queue and save"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BuyQueueBanner/images/bg.jpg
const BuyQueueBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_393d3c.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BuyQueueBanner/BuyQueueBanner.tsx






const BuyQueueBanner = (param)=>{
    let { onClick } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.buyQueue,
        title: BuyQueueBanner_messages.title,
        text: BuyQueueBanner_messages.text,
        bgImage: BuyQueueBanner_images_bg_namespaceObject,
        buttonTitle: BuyQueueBanner_messages.buttonTitle,
        content: "Buy your queue",
        sizes: "560px",
        onClick: onClick,
        "data-testid": "buyQueueBanner"
    });
};
/* harmony default export */ const BuyQueueBanner_BuyQueueBanner = (BuyQueueBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/util/useDesktopNav.tsx
















const getGiftHubNavigationItemData = (isHolidayMothersDayEnabled, isHolidayFathersDayEnabled)=>{
    if (isHolidayMothersDayEnabled) {
        return {
            background: "faded-pink",
            exclusiveLabelVariant: "pink",
            title: navigation_messages/* default */.Z.holidayGiftsMothersDay
        };
    }
    if (isHolidayFathersDayEnabled) {
        return {
            background: "gold-50",
            exclusiveLabelVariant: "gold-50",
            title: navigation_messages/* default */.Z.holidayGiftsFathersDay
        };
    }
    return {
        background: "vinous",
        exclusiveLabelVariant: "gold",
        title: navigation_messages/* default */.Z.gifts
    };
};
const useDesktopNav = ()=>{
    var _strapiWSTONavigationData_banners, _strapiWSTONavigationData_banners1, _strapiWSTONavigationData_banners2, _subscription_stateOptions;
    const isTheEditEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theEdit);
    const isTheShopEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theShop);
    const isCandleSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleSubscription);
    const isFragranceFamiliesPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.fragranceFamiliesPage);
    const isNotesLibraryPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.noteLibPages);
    const isSaksCollaborationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.collaborationSaks);
    const isGiftHubEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHub);
    const isHolidayMothersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayMothersDay);
    const isHolidayFathersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayFathersDay);
    const isScentHoroscopeEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.scentHoroscope);
    const isShopSamplesEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.shopSamples);
    const isScentbirdPodcastEntryPointsEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.scentbirdPodcastEntryPoints);
    const isTravelSizeEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.travelSizeFragrances);
    const isDriftEcommercePromoEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftEcommercePromo);
    const isMemorialSaleLabelEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.memorialSale);
    const isCOARShopPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.coarShopPage);
    const isDriftSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftSubscription);
    const isScentbirdAcademyEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.scentbirdAcademy);
    const isGiftsUnder50PageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftsUnder50Page);
    const isBuy5pay4Enabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.buy5pay4);
    const isPalmRoyaleCollaborationEnabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.palmRoyaleCollaboration);
    const { gender, hasScentProfile } = (0,user/* useUser */.aF)();
    const strapiWSTONavigationData = (0,useStrapiWSTONavigationData/* default */.Z)();
    const isStrapiWSTONavigationDataEnabled = Boolean(strapiWSTONavigationData);
    const isStrapiWSTONavigationPerfumesBannerExists = Boolean(strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners === void 0 ? void 0 : _strapiWSTONavigationData_banners.perfumes);
    const isStrapiWSTONavigationColognesBannerExists = Boolean(strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners1 = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners1 === void 0 ? void 0 : _strapiWSTONavigationData_banners1.colognes);
    const isStrapiWSTONavigationDiscoverBannerExists = Boolean(strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners2 = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners2 === void 0 ? void 0 : _strapiWSTONavigationData_banners2.discover);
    const { privateSale } = (0,usePrivateSale/* default */.Z)();
    const isPrivateSaleEnabled = Boolean(privateSale);
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const isSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.isSubscribed;
    const isBuyQueueEnabled = subscription === null || subscription === void 0 ? void 0 : (_subscription_stateOptions = subscription.stateOptions) === null || _subscription_stateOptions === void 0 ? void 0 : _subscription_stateOptions.canBuyQueue;
    const canApplyTossInOffer = subscription === null || subscription === void 0 ? void 0 : subscription.canApplyTossInOffer;
    const { caseSubscription } = (0,subscriptionAddons/* useCaseSubscription */.PZ)();
    const isCaseSubscriptionEnabled = caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isEnabled;
    const isCaseSubscriptionSelected = caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isSelected;
    const { candleSubscription } = (0,subscriptionAddons/* useCandleSubscription */.pj)();
    const isCandleSubscriptionSelected = candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected;
    const isCandleSubscriptionVisible = Boolean(isCandleSubscriptionEnabled && (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled));
    const { driftSubscription } = (0,subscriptionAddons/* useDriftSubscription */.RD)();
    const isDriftSubscriptionSelected = driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected;
    const isDriftSubscriptionVisible = Boolean(isDriftSubscriptionEnabled && (driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isEnabled));
    const { stats: { available } } = (0,referralProgram/* useReferralInvites */.n)();
    const isReferralItemVisible = Boolean(available);
    const isTopLevelCandleClubEntryPointVisible = isCandleSubscriptionVisible && !isCandleSubscriptionSelected;
    let discoverSectionBanner = isStrapiWSTONavigationDiscoverBannerExists ? StrapiWSTONavigationBanner/* default */.Z : DynamicNavigationBanner_DynamicNavigationBanner;
    const perfumesSectionBanner = isStrapiWSTONavigationPerfumesBannerExists ? StrapiWSTONavigationBanner/* default */.Z : DynamicNavigationBanner_DynamicNavigationBanner;
    const colognesSectionBanner = isStrapiWSTONavigationColognesBannerExists ? StrapiWSTONavigationBanner/* default */.Z : DynamicNavigationBanner_DynamicNavigationBanner;
    const isUpgradeEntryPointsEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.upgradeEntryPoints) === "b" && (subscription === null || subscription === void 0 ? void 0 : subscription.isUpgradableFromMonthlyPlan);
    const isScentHoroscopeInPerfumesEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.navScentHoroscopeInPerfumes) === "b";
    const isRecommendedForYouLinkEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.recommendedForYouNavLink) === "b";
    const isTheValentinesEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theValentinesEdit) === "b";
    const isTheLuxeEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theLuxeEdit) === "b";
    let theEditTitle = navigation_messages/* default */.Z.edit;
    if (isTheValentinesEditEnabled) {
        theEditTitle = messages_messages/* default */.Z.theValentinesEdit;
    } else if (isTheLuxeEditEnabled) {
        theEditTitle = messages_messages/* default */.Z.theLuxeEdit;
    }
    const theEditRef = (0,react.useCallback)((node)=>{
        if (node && isTheEditEnabled && !(isTheValentinesEditEnabled || isTheLuxeEditEnabled)) {
            (0,analytics/* track */.j)("The Edit entry point display");
        }
    }, [
        isTheEditEnabled,
        isTheValentinesEditEnabled,
        isTheLuxeEditEnabled
    ]);
    return (0,react.useMemo)(()=>{
        const giftHubNavigationItemData = isGiftHubEnabled ? getGiftHubNavigationItemData(isHolidayMothersDayEnabled, isHolidayFathersDayEnabled) : null;
        const onFragranceMenuDisplay = ()=>{
            const context = (0,analytics_context/* getAnalyticsContext */.cV)();
            (0,analytics/* track */.j)("Menu display");
            if (context.subscriptionStatus !== "LEAD") {
                (0,analytics/* trackOnce */.Cn)("Fragrances menu display");
            }
        };
        const collaborationItem = isSaksCollaborationEnabled && {
            id: "header-discover-scentbird-select",
            title: navigation_messages/* default */.Z.scentbirdSelect,
            to: links/* default */.ZP.scentbirdSelect,
            label: navigation_messages/* default */.Z.labels.new
        };
        const recommendedForYouItem = {
            id: "recommended-for-you",
            title: navigation_messages/* default */.Z.recommendedForYou,
            to: links/* default */.ZP.scentProfile
        };
        const data = [
            {
                id: "perfumes",
                title: navigation_messages/* default */.Z.perfumes,
                list: [
                    {
                        id: "perfumes-all",
                        title: navigation_messages/* default */.Z.allPerfumes,
                        to: links/* default */.ZP.subscription.perfumes
                    },
                    isRecommendedForYouLinkEnabled && gender === "MALE" && recommendedForYouItem,
                    collaborationItem,
                    isScentHoroscopeInPerfumesEnabled && isScentHoroscopeEnabled && {
                        id: "header-discover-scentHoroscope",
                        title: navigation_messages/* default */.Z.scentHoroscope,
                        to: links/* default */.ZP.scentHoroscope,
                        label: navigation_messages/* default */.Z.labels.new
                    },
                    {
                        id: "perfumes-new-arrivals",
                        title: navigation_messages/* default */.Z.newArrivals,
                        to: links/* default */.ZP.newArrivals.perfumes
                    },
                    {
                        id: "perfumes-bestsellers",
                        title: navigation_messages/* default */.Z.bestsellers,
                        to: links/* default */.ZP.bestsellers.perfumes
                    },
                    {
                        id: "perfumes-pom",
                        title: navigation_messages/* default */.Z.pom,
                        to: links/* default */.ZP.subscription.currentPerfumeOfTheMonth
                    },
                    {
                        id: "perfumes-clean",
                        title: navigation_messages/* default */.Z.clean,
                        to: links/* default */.ZP.clean.perfumes
                    },
                    {
                        id: "perfumes-exclusive",
                        title: navigation_messages/* default */.Z.exclusive,
                        to: `${links/* default */.ZP.subscription.perfumes}?category=exclusive`
                    },
                    {
                        id: "perfumes-collections",
                        title: navigation_messages/* default */.Z.collections,
                        to: links/* default */.ZP.collectionsWomen
                    },
                    {
                        id: "header-discover-allBrands",
                        title: navigation_messages/* default */.Z.allBrands,
                        to: links/* default */.ZP.brands
                    }
                ].filter(Boolean),
                withColumns: true,
                bannerComponent: perfumesSectionBanner,
                onDisplay: onFragranceMenuDisplay
            },
            {
                id: "colognes",
                title: navigation_messages/* default */.Z.colognes,
                list: [
                    {
                        id: "colognes-all",
                        title: navigation_messages/* default */.Z.allColognes,
                        to: links/* default */.ZP.subscription.colognes
                    },
                    isRecommendedForYouLinkEnabled && gender === "FEMALE" && recommendedForYouItem,
                    collaborationItem,
                    isScentHoroscopeInPerfumesEnabled && isScentHoroscopeEnabled && {
                        id: "header-discover-scentHoroscope",
                        title: navigation_messages/* default */.Z.scentHoroscope,
                        to: links/* default */.ZP.scentHoroscope,
                        label: navigation_messages/* default */.Z.labels.new
                    },
                    {
                        id: "colognes-new-arrivals",
                        title: navigation_messages/* default */.Z.newArrivals,
                        to: links/* default */.ZP.newArrivals.colognes
                    },
                    {
                        id: "colognes-bestsellers",
                        title: navigation_messages/* default */.Z.bestsellers,
                        to: links/* default */.ZP.bestsellers.colognes
                    },
                    {
                        id: "colognes-com",
                        title: navigation_messages/* default */.Z.com,
                        to: links/* default */.ZP.subscription.currentCologneOfTheMonth
                    },
                    {
                        id: "colognes-clean",
                        title: navigation_messages/* default */.Z.clean,
                        to: links/* default */.ZP.clean.colognes
                    },
                    {
                        id: "colognes-exclusive",
                        title: navigation_messages/* default */.Z.exclusive,
                        to: `${links/* default */.ZP.subscription.colognes}?category=exclusive`
                    },
                    {
                        id: "colognes-collections",
                        title: navigation_messages/* default */.Z.collections,
                        to: links/* default */.ZP.collectionsMen
                    },
                    {
                        id: "header-discover-allBrands",
                        title: navigation_messages/* default */.Z.allBrands,
                        to: links/* default */.ZP.brands
                    }
                ].filter(Boolean),
                withColumns: true,
                bannerComponent: colognesSectionBanner,
                onDisplay: onFragranceMenuDisplay
            },
            {
                id: "beauty",
                title: navigation_messages/* default */.Z.beauty,
                to: links/* default */.ZP.subscription.beauty
            },
            isUpgradeEntryPointsEnabled && {
                id: "header-upgrade",
                title: navigation_messages/* default */.Z.upgrade2Scents,
                to: links/* default */.ZP.upgradeProduct
            },
            !isUpgradeEntryPointsEnabled && isTopLevelCandleClubEntryPointVisible && {
                id: "candleClub",
                title: navigation_messages/* default */.Z.candleSubscription,
                to: links/* default */.ZP.candleSubscription
            },
            {
                isDivider: true
            },
            {
                id: "shop",
                title: navigation_messages/* default */.Z.shop,
                list: [
                    isGiftHubEnabled && {
                        id: "header-gift-hub",
                        title: giftHubNavigationItemData.title,
                        to: links/* default */.ZP.gifts
                    },
                    isGiftsUnder50PageEnabled && {
                        id: "header-giftsUnder50",
                        title: navigation_messages/* default */.Z.giftsUnder50,
                        to: links/* default */.ZP.giftsUnder50
                    },
                    isDriftEcommercePromoEnabled && {
                        id: "header-drift-ecommerce-promo",
                        title: navigation_messages/* default */.Z.driftEcommercePromo,
                        to: `${(0,getLinkWithParams/* default */.Z)(links/* default */.ZP.brand, {
                            name: "drift"
                        })}?productInputSource=THE_EDIT&sourceProductGroup=GiftSet`,
                        label: navigation_messages/* default */.Z.labels.new
                    },
                    isTravelSizeEnabled && {
                        id: "header-shop-travelSizeFragrances",
                        title: navigation_messages/* default */.Z.travelSizeFragrances,
                        to: gender === "FEMALE" ? links/* default */.ZP.shop.travelSize.perfumes : links/* default */.ZP.shop.travelSize.colognes,
                        label: isBuy5pay4Enabled ? navigation_messages/* default */.Z.labels.sale : undefined
                    },
                    isShopSamplesEnabled && {
                        id: "header-shop-samples",
                        title: navigation_messages/* default */.Z.samples,
                        to: links/* default */.ZP.shop.samples.root
                    },
                    isScentbirdAcademyEnabled && {
                        id: "header-scentbird-academy",
                        title: navigation_messages/* default */.Z.scentbirdAcademy,
                        to: links/* default */.ZP.academy.root,
                        label: navigation_messages/* default */.Z.labels.new
                    },
                    isTheShopEnabled && {
                        id: "header-shop-fullSizeFragrances",
                        title: navigation_messages/* default */.Z.fullSizeFragrances,
                        to: gender === "FEMALE" ? links/* default */.ZP.shop.perfumes : links/* default */.ZP.shop.colognes,
                        label: isMemorialSaleLabelEnabled && navigation_messages/* default */.Z.labels.sale
                    },
                    isCOARShopPageEnabled && {
                        id: "header-shop-coar",
                        title: navigation_messages/* default */.Z.coarShopPage,
                        to: links/* default */.ZP.shop.coar,
                        label: navigation_messages/* default */.Z.labels.new
                    },
                    isTheEditEnabled && {
                        id: "header-shop-edit",
                        title: theEditTitle,
                        to: links/* default */.ZP.shop.theEdit,
                        label: isMemorialSaleLabelEnabled && navigation_messages/* default */.Z.labels.sale,
                        ref: theEditRef
                    },
                    isTheShopEnabled && {
                        id: "header-shop-candlesHomeScents",
                        title: navigation_messages/* default */.Z.candlesHomeScents,
                        to: links/* default */.ZP.shop.candlesHomeScents,
                        label: isMemorialSaleLabelEnabled && navigation_messages/* default */.Z.labels.sale
                    },
                    {
                        id: "header-shop-scentbirdCases",
                        title: navigation_messages/* default */.Z.scentbirdCases,
                        to: links/* default */.ZP.shop.scentbirdCases
                    }
                ].filter(Boolean),
                subNavLinksPosition: "right",
                withColumns: true,
                bannerComponent: DynamicNavigationBanner_DynamicNavigationBanner
            },
            {
                id: "discover",
                title: navigation_messages/* default */.Z.discover,
                list: [
                    {
                        id: "header-discover-scentProfile",
                        title: navigation_messages/* default */.Z.scentProfile,
                        to: hasScentProfile ? links/* default */.ZP.scentProfile : links/* default */.ZP.smartRecommendations
                    },
                    isStrapiWSTONavigationDataEnabled && {
                        id: "header-discover-featuredBrand",
                        title: navigation_messages/* default */.Z.featuredBrand,
                        to: strapiWSTONavigationData.navLink
                    },
                    !isScentHoroscopeInPerfumesEnabled && isScentHoroscopeEnabled && {
                        id: "header-discover-scentHoroscope",
                        title: navigation_messages/* default */.Z.scentHoroscope,
                        to: links/* default */.ZP.scentHoroscope,
                        label: navigation_messages/* default */.Z.labels.new
                    },
                    {
                        id: "header-discover-fomArchive",
                        title: navigation_messages/* default */.Z.fomArchive,
                        to: links/* default */.ZP.subscription.perfumeOfTheMonthList
                    },
                    isScentbirdAcademyEnabled && {
                        id: "header-scentbird-academy",
                        title: navigation_messages/* default */.Z.scentbirdAcademy,
                        to: links/* default */.ZP.academy.root,
                        label: navigation_messages/* default */.Z.labels.new
                    },
                    isNotesLibraryPageEnabled && {
                        id: "header-discover-notesLibrary",
                        title: navigation_messages/* default */.Z.notesLibrary,
                        to: links/* default */.ZP.notes
                    },
                    isFragranceFamiliesPageEnabled && {
                        id: "header-discover-fragranceFamilies",
                        title: navigation_messages/* default */.Z.fragranceFamilies,
                        to: links/* default */.ZP.fragranceFamilies
                    },
                    {
                        id: "header-discover-scentBlog",
                        title: navigation_messages/* default */.Z.scentBlog,
                        toTab: links/* default */.ZP.blog
                    },
                    isScentbirdPodcastEntryPointsEnabled && {
                        id: "header-discover-podcast",
                        title: navigation_messages/* default */.Z.scentWorldPodcast,
                        href: constants/* default */.Z.externalLinks.scentbirdPodcast,
                        label: navigation_messages/* default */.Z.labels.new
                    },
                    isPalmRoyaleCollaborationEnabled && {
                        id: "header-discover-palm-royale",
                        title: navigation_messages/* default */.Z.palmRoyaleCollaboration,
                        to: (0,getLinkWithParams/* default */.Z)(links/* default */.ZP.pr.landing, {
                            slug: "palmroyale"
                        }),
                        label: navigation_messages/* default */.Z.labels.new
                    }
                ].filter(Boolean),
                subNavLinksPosition: "right",
                withColumns: true,
                bannerComponent: discoverSectionBanner,
                onDisplay: ()=>{
                    const context = (0,analytics_context/* getAnalyticsContext */.cV)();
                    if (context.subscriptionStatus !== "LEAD") {
                        (0,analytics/* trackOnce */.Cn)("Discover menu display");
                    }
                }
            },
            isSubscribed && {
                id: "member perks",
                title: navigation_messages/* default */.Z.memberPerks,
                list: [
                    isDriftSubscriptionVisible && {
                        id: "header-member-perks-driftSubscription",
                        title: navigation_messages/* default */.Z.driftSubscription,
                        to: links/* default */.ZP.driftSubscription,
                        label: isDriftSubscriptionSelected ? navigation_messages/* default */.Z.labels.subscribed : navigation_messages/* default */.Z.labels.new
                    },
                    isBuyQueueEnabled && {
                        id: "header-member-perks-buyYourQueue",
                        title: navigation_messages/* default */.Z.buyYourQueue,
                        to: links/* default */.ZP.buyQueue
                    },
                    isPrivateSaleEnabled && {
                        id: "header-member-perks-privateSale",
                        title: navigation_messages/* default */.Z.privateSale,
                        to: links/* default */.ZP.privateSale
                    },
                    isReferralItemVisible && {
                        id: "referral-nav-item",
                        to: links/* default */.ZP.invite,
                        title: navigation_messages/* default */.Z.referralProgram,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferralNavItem/* default */.Z, {
                            spanClassName: "text-white bg-gold-70 text-p4",
                            freeFragranceClassName: "text-gold-70"
                        })
                    },
                    canApplyTossInOffer && {
                        id: "header-member-perks-lastMinuteAddons",
                        title: navigation_messages/* default */.Z.lastMinuteAddons,
                        to: links/* default */.ZP.tossIn
                    },
                    isCaseSubscriptionEnabled && {
                        id: "header-member-perks-caseSubscription",
                        title: navigation_messages/* default */.Z.caseSubscription,
                        to: links/* default */.ZP.caseSubscription
                    },
                    isCandleSubscriptionVisible && {
                        id: "header-member-perks-candleSubscription",
                        title: navigation_messages/* default */.Z.candleSubscription,
                        to: links/* default */.ZP.candleSubscription,
                        label: isCandleSubscriptionSelected ? navigation_messages/* default */.Z.labels.subscribed : navigation_messages/* default */.Z.labels.new
                    }
                ].filter(Boolean),
                subNavLinksPosition: "right",
                withColumns: false,
                bannerComponent: (param)=>{
                    let { onClick } = param;
                    if (isDriftSubscriptionVisible && !isDriftSubscriptionSelected) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DriftSubscriptionNavBanner_DriftSubscriptionNavBanner, {
                            onClick: onClick
                        });
                    }
                    if (isCandleSubscriptionVisible && !isCandleSubscriptionSelected) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleSubscriptionBanner_CandleSubscriptionBanner, {
                            onClick: onClick
                        });
                    }
                    if (isCaseSubscriptionEnabled && !isCaseSubscriptionSelected) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseSubscriptionBanner_CaseSubscriptionBanner, {
                            onClick: onClick
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyQueueBanner_BuyQueueBanner, {
                        onClick: onClick
                    });
                }
            },
            {
                id: "gifts",
                title: navigation_messages/* default */.Z.gifts,
                list: [
                    isGiftHubEnabled && {
                        id: "header-gift-hub",
                        title: giftHubNavigationItemData.title,
                        to: links/* default */.ZP.gifts,
                        exclusiveLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclusiveLabel/* default */.Z, {
                            labelText: navigation_messages/* default */.Z.exclusives,
                            variant: giftHubNavigationItemData.exclusiveLabelVariant
                        })
                    },
                    {
                        id: "header-gifts-subscription",
                        title: navigation_messages/* default */.Z.giftSubscription,
                        to: links/* default */.ZP.giftSubscription
                    },
                    isGiftsUnder50PageEnabled && {
                        id: "header-gifts-giftsUnder50",
                        title: navigation_messages/* default */.Z.giftsUnder50,
                        to: links/* default */.ZP.giftsUnder50
                    },
                    {
                        id: "header-gifts-card",
                        title: navigation_messages/* default */.Z.giftCard,
                        to: links/* default */.ZP.giftCard
                    },
                    {
                        id: "header-gift-sets",
                        title: navigation_messages/* default */.Z.giftSets,
                        to: links/* default */.ZP.giftSets.root
                    },
                    !isGiftHubEnabled && {
                        id: "header-gifts",
                        title: navigation_messages/* default */.Z.allGifts,
                        to: links/* default */.ZP.gifts
                    }
                ].filter(Boolean),
                subNavLinksPosition: "right",
                background: giftHubNavigationItemData === null || giftHubNavigationItemData === void 0 ? void 0 : giftHubNavigationItemData.background,
                withColumns: false,
                bannerComponent: DynamicNavigationBanner_DynamicNavigationBanner
            }
        ];
        return data.filter(Boolean);
    }, [
        gender,
        hasScentProfile,
        discoverSectionBanner,
        isGiftHubEnabled,
        isStrapiWSTONavigationDataEnabled,
        strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : strapiWSTONavigationData.navLink,
        isTheEditEnabled,
        isBuyQueueEnabled,
        canApplyTossInOffer,
        isCandleSubscriptionVisible,
        isCandleSubscriptionSelected,
        isCaseSubscriptionEnabled,
        isCaseSubscriptionSelected,
        isFragranceFamiliesPageEnabled,
        isNotesLibraryPageEnabled,
        isSubscribed,
        isTheShopEnabled,
        isPrivateSaleEnabled,
        isTopLevelCandleClubEntryPointVisible,
        isSaksCollaborationEnabled,
        isScentHoroscopeEnabled,
        isHolidayMothersDayEnabled,
        isHolidayFathersDayEnabled,
        isShopSamplesEnabled,
        isScentbirdPodcastEntryPointsEnabled,
        isReferralItemVisible,
        perfumesSectionBanner,
        colognesSectionBanner,
        isUpgradeEntryPointsEnabled,
        isTravelSizeEnabled,
        isDriftEcommercePromoEnabled,
        isMemorialSaleLabelEnabled,
        isCOARShopPageEnabled,
        isScentHoroscopeInPerfumesEnabled,
        isDriftSubscriptionVisible,
        isDriftSubscriptionSelected,
        isScentbirdAcademyEnabled,
        isGiftsUnder50PageEnabled,
        isBuy5pay4Enabled,
        isPalmRoyaleCollaborationEnabled,
        isRecommendedForYouLinkEnabled,
        theEditTitle
    ]);
};
/* harmony default export */ const util_useDesktopNav = (useDesktopNav);

// EXTERNAL MODULE: ./src/components/navigation/HoverablePopover/HoverablePopover.tsx + 3 modules
var HoverablePopover = __webpack_require__(29365);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/NavRootItem/NavRootItem.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const NavRootItem_module = ({"activeButton":"cXgL6n"});
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/NavRootItem/NavRootItem.tsx










const backgroundToClassName = {
    "faded-pink": "bg-faded-pink",
    "gold-50": "bg-gold-50",
    "vinous": "bg-vinous"
};
const NavRootItem = (props)=>{
    const { className, data, style, color, background, hoverColor, activeColor, isActive, popoverPanelClassName, groupOpenedPopoverCountRef, "data-testid": dataTestId } = props;
    const { id, title: sectionTitle, list, subNavLinksPosition, withColumns, bannerComponent, onDisplay } = data;
    const intl = (0,useIntl/* default */.Z)();
    const formattedTitle = intl.formatMessage(sectionTitle);
    const buttonClassNames = (0,clsx/* default */.Z)(className, "flex cursor-pointer items-center", backgroundToClassName[background], {
        [`text-${style}`]: style,
        [`hover:text-${hoverColor}`]: hoverColor,
        [`text-${color}`]: color && !isActive,
        [`text-${activeColor}`]: activeColor && isActive
    });
    const isColumnFlowEnabled = withColumns && list.length > 5;
    /*
   rearrange items to split them into 2 columns like:
   0 3
   1 4
   2 5
   will be represented as [ 0, 3, 1, 4, 2, 5 ] array
   it is required to split by items count, not items content to provide more control
   */ const itemsByColumns = isColumnFlowEnabled ? list.map((_, index)=>{
        const halfLength = Math.ceil(list.length / 2);
        const halfIndex = Math.floor(index / 2);
        return list[index % 2 * halfLength + halfIndex];
    }) : list;
    const isMenuOnRightSide = subNavLinksPosition === "right";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z, {
        className: "flex items-stretch",
        groupOpenedPopoverCountRef: groupOpenedPopoverCountRef,
        children: (param)=>{
            let { open, close } = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z.Button, {
                        className: (0,clsx/* default */.Z)(buttonClassNames, {
                            [NavRootItem_module.activeButton]: open,
                            [`text-${activeColor}`]: open && activeColor
                        }),
                        "data-testid": dataTestId,
                        children: formattedTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z.Overlay, {
                        withDefaultStyle: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z.Panel, {
                        className: (0,clsx/* default */.Z)(popoverPanelClassName, "absolute left-0 top-full z-10 w-full bg-white py-24 text-black"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
                            className: (0,clsx/* default */.Z)("flex items-start", isMenuOnRightSide && "flex-row-reverse"),
                            children: [
                                Boolean(onDisplay) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayTracker, {
                                    onDisplay: onDisplay
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1 px-24",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        role: "list",
                                        className: (0,clsx/* default */.Z)(isMenuOnRightSide ? "mx-auto w-[400rem]" : "ml-auto w-[384rem]", isColumnFlowEnabled && "grid grid-cols-2 gap-x-16"),
                                        children: itemsByColumns.map((param)=>{
                                            let { id, title, to, href, toTab, label, content, exclusiveLabel, highlight, ref } = param;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                                                    className: (0,clsx/* default */.Z)("inline-block py-10", highlight && "font-bold"),
                                                    ref: ref,
                                                    title: title,
                                                    to: to,
                                                    href: href,
                                                    toTab: toTab,
                                                    label: label,
                                                    content: content,
                                                    exclusiveLabel: exclusiveLabel,
                                                    style: "p2",
                                                    color: highlight ? "gold-70" : "black",
                                                    hoverColor: "gold-30",
                                                    activeColor: "gold-30",
                                                    onClick: ()=>{
                                                        (0,analytics/* track */.j)("Desktop navigation menu click", {
                                                            blockName: (0,sanitizeForAnalytics/* default */.Z)(typeof sectionTitle === "string" ? sectionTitle : sectionTitle.en),
                                                            title: (0,sanitizeForAnalytics/* default */.Z)(typeof title === "string" ? title : title.en),
                                                            link: to || toTab || href
                                                        });
                                                        close();
                                                    },
                                                    "data-testid": id
                                                })
                                            }, id);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[560rem] flex-none",
                                    children: bannerComponent ? /*#__PURE__*/ react.createElement(bannerComponent, {
                                        placement: id,
                                        onClick: close
                                    }) : null
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
const DisplayTracker = (param)=>{
    let { onDisplay } = param;
    (0,react.useEffect)(()=>{
        onDisplay();
    }, [
        onDisplay
    ]);
    return null;
};
/* harmony default export */ const NavRootItem_NavRootItem = (/*#__PURE__*/react.memo(NavRootItem));

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/Nav/Nav.tsx









const Nav = ()=>{
    const pathname = (0,hooks/* usePathname */.jD)();
    const [searchParams] = (0,hooks/* useSearchParams */.lr)();
    const items = util_useDesktopNav();
    const groupOpenedPopoverCountRef = (0,react.useRef)(0);
    const activeTabLink = "tab" in searchParams ? `${pathname}?tab=${searchParams.tab}` : pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J.Group, {
        as: NavList/* default */.Z,
        className: "ml-32 flex flex-1 items-stretch self-stretch",
        listClassName: "flex items-stretch",
        "aria-label": "Main",
        children: items.map((item)=>{
            if ("isDivider" in item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDivider_NavDivider, {
                    className: "mx-12 self-center"
                }, "divider");
            }
            const { id, title, to, list, content } = item;
            const isActive = to === activeTabLink || (list === null || list === void 0 ? void 0 : list.some((param)=>{
                let { to } = param;
                return(// this check required because we have different approach to pages with tabs:
                // - same pathname with tabs in perfumes/colognes subNav
                // - only pathname without tabs (but page has tabs), e.g. discover/brands
                (to === null || to === void 0 ? void 0 : to.includes("?tab")) ? to === activeTabLink : to === pathname);
            }));
            if (list) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex items-stretch",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavRootItem_NavRootItem, {
                        className: "px-12",
                        style: "p2",
                        color: "white",
                        hoverColor: "gold-30",
                        activeColor: "gold-30",
                        data: item,
                        background: item.background,
                        groupOpenedPopoverCountRef: groupOpenedPopoverCountRef,
                        "data-testid": id
                    })
                }, id);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "flex items-stretch px-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                    className: "flex items-center",
                    style: "p2",
                    color: "white",
                    content: content,
                    hoverColor: "gold-30",
                    activeColor: "gold-30",
                    to: to,
                    title: title,
                    isActive: isActive,
                    onClick: ()=>{
                        (0,analytics/* track */.j)("Desktop navigation menu click", {
                            blockName: (0,sanitizeForAnalytics/* default */.Z)(typeof title === "string" ? title : title.en),
                            title: (0,sanitizeForAnalytics/* default */.Z)(typeof title === "string" ? title : title.en),
                            link: to
                        });
                    },
                    "data-testid": id
                })
            }, id);
        })
    });
};
/* harmony default export */ const Nav_Nav = (Nav);

// EXTERNAL MODULE: ./src/compositions/Header/view/Desktop/components/UserNav/UserNav.tsx
var UserNav = __webpack_require__(6195);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/Desktop.tsx






const Desktop = (props)=>{
    const { withBanner = true, withSupNav = true, withQueueCounter, loginWithBackRedirect, logoLink, withChatAssistance } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipContent/* default */.Z, {
                contentId: "main"
            }),
            withBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {}),
            withSupNav && /*#__PURE__*/ (0,jsx_runtime.jsx)(SupNav_SupNav, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainHeader/* default */.Z, {
                size: withQueueCounter ? 1312 : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink/* default */.Z, {
                        color: "white",
                        to: logoLink
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Nav, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-flow-col items-center gap-8",
                        children: [
                            withChatAssistance && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatAssistance_ChatAssistance, {}),
                            withQueueCounter && /*#__PURE__*/ (0,jsx_runtime.jsx)(QueueCounter/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNavWrapper/* default */.Z, {
                                withRedirect: loginWithBackRedirect,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNav/* default */.Z, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const Desktop_Desktop = (Desktop);


/***/ }),

/***/ 6195:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25747);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2129);
/* harmony import */ var _growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26853);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63687);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95812);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80550);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34346);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94957);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40038);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36888);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35544);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29365);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29564);
/* harmony import */ var compositions_navigation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1867);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57183);
/* harmony import */ var _components_Section_Section__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2286);


















const QueueBanner = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName () {
        return "compositions-Header-components-QueueBanner-QueueBanner";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: ()=>Promise.all(/* import() | compositions-Header-components-QueueBanner-QueueBanner */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(2912), __webpack_require__.e(8371), __webpack_require__.e(1132), __webpack_require__.e(2230)]).then(__webpack_require__.bind(__webpack_require__, 53233)),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve () {
        if (true) {
            return /*require.resolve*/(53233);
        }
        return eval("require.resolve")("compositions/Header/components/QueueBanner/QueueBanner");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "gray-90 !mix-blend-normal",
        pw: 100,
        h: 100
    })
});
const UserNav = ()=>{
    const sections = (0,_util__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const isAaTestUserNav = (0,_growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_3__/* .useFeatureIsOn */ .cC)(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.features.aaUserNav);
    const { user } = (0,modules_user__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .aF)();
    const firstName = user === null || user === void 0 ? void 0 : user.firstName;
    const lastName = user === null || user === void 0 ? void 0 : user.lastName;
    const intl = (0,intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    const buttonAriaLabel = intl.formatMessage(compositions_navigation__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z.aria.profileButton);
    const { subscription } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_10__/* .useSubscription */ .mU)();
    const isSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.isSubscribed;
    const isQueueNavBannerEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.abTests.queueNavBanner) === "b";
    const isQueueNavBannerVisible = isQueueNavBannerEnabled && isSubscribed;
    // TODO: Remove this tracking after CRO-344 ab test is over
    const handleDisplay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        (0,analytics__WEBPACK_IMPORTED_MODULE_12__/* .track */ .j)("Desktop profile menu display");
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        className: "align-center relative flex h-full justify-center",
        children: (param)=>{
            let { open, close } = param;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.Button, {
                        "data-testid": "profileMenuBtn",
                        "aria-label": buttonAriaLabel,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            firstName: firstName,
                            lastName: lastName,
                            size: 40,
                            isActive: open,
                            "data-testid": "userAvatar"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_navigation__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.Panel, {
                        as: "nav",
                        className: "absolute right-0 bg-black pr-40 pt-32 text-right desktop:top-full desktop:w-[368rem]",
                        "aria-label": "Profile",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DisplayTracker, {
                                onDisplay: handleDisplay
                            }),
                            isQueueNavBannerVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(router__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .r, {
                                className: "-mr-24 -mt-16 mb-40 ml-16 block",
                                to: links__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP.queue,
                                onClick: ()=>{
                                    (0,analytics__WEBPACK_IMPORTED_MODULE_12__/* .track */ .j)("Desktop profile menu click", {
                                        link: links__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP.queue,
                                        title: "Manage your fragrances",
                                        blockName: "Your membership"
                                    });
                                    close();
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QueueBanner, {
                                    isDark: true
                                })
                            }),
                            sections.map((data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section_Section__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    data: data,
                                    closeNav: close
                                }, data.id))
                        ]
                    })
                ]
            });
        }
    });
};
const DisplayTracker = (param)=>{
    let { onDisplay } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        onDisplay();
    }, [
        onDisplay
    ]);
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(UserNav));


/***/ }),

/***/ 2286:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95812);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91746);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78565);
/* harmony import */ var compositions_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23091);






const Section = (param)=>{
    let { data, closeNav } = param;
    const pathname = (0,router__WEBPACK_IMPORTED_MODULE_2__/* .usePathname */ .jD)();
    const { title: sectionTitle, list } = data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                message: sectionTitle,
                style: "h8",
                color: "gold-30"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "mb-24 mt-8 text-white",
                children: list.map((param)=>{
                    let { id, title, label, to, toTab, content, onClick } = param;
                    const handleClick = (event)=>{
                        closeNav();
                        (0,analytics__WEBPACK_IMPORTED_MODULE_4__/* .track */ .j)("Desktop profile menu click", {
                            link: to,
                            title: typeof title === "string" ? title : title.en,
                            blockName: typeof sectionTitle === "string" ? sectionTitle : sectionTitle.en
                        });
                        if (typeof onClick === "function") {
                            onClick(event);
                        }
                    };
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_navigation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: "block py-12",
                        title: title,
                        label: label,
                        to: to,
                        toTab: toTab,
                        content: content,
                        style: "p2",
                        hoverColor: "gold-30",
                        activeColor: "gold-30",
                        labelColor: "gold-30",
                        isActive: pathname === to,
                        "data-testid": id,
                        onClick: handleClick
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Section));


/***/ }),

/***/ 55988:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94957);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9424);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63687);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95812);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36888);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53409);








const LogoLink = (props)=>{
    const { className, to: customLink, color } = props;
    const { subscription } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscription */ .mU)();
    const defaultLink = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) === false ? links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main : cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.logoRedirectUrl) || links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home;
    const to = customLink === undefined ? defaultLink : customLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: className,
        to: to,
        color: color,
        onClick: ()=>{
            (0,analytics__WEBPACK_IMPORTED_MODULE_7__/* .track */ .j)("Scentbird logo click");
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LogoLink);


/***/ }),

/***/ 61835:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78364);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95812);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(927);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35838);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76884);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78565);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30468);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45881);








const BannerBase = (props)=>{
    const { "data-testid": dataTestId = "banner", bgImage, buttonStyle, buttonTitle, content, logo, logoClassName, onClick, text, textColor, title, titleClassName, titleColor, to, toTab, href, placement = "Desktop navigation menu", trackParams = {}, caption, height = 296, sizes } = props;
    const handleClick = ()=>{
        (0,analytics__WEBPACK_IMPORTED_MODULE_2__/* .track */ .j)("Banner click", {
            placement,
            content,
            link: to,
            action: "link",
            ...trackParams
        });
        if (typeof onClick === "function") {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        to: to,
        href: href,
        toTab: toTab,
        onClick: handleClick,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: "flex flex-col items-start justify-center bg-light-beige p-32",
            imageClassName: "object-left",
            src: bgImage,
            quality: 85,
            sizes: sizes,
            style: {
                height: `${height}rem`
            },
            children: [
                Boolean(logo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    className: logoClassName,
                    src: logo,
                    alt: ""
                }),
                Boolean(title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                    className: (0,classnames__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("whitespace-pre-line", titleClassName),
                    style: "h7",
                    color: titleColor,
                    message: title,
                    html: true
                }),
                Boolean(text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                    className: "mt-16 whitespace-pre-line",
                    style: "p3",
                    color: textColor,
                    message: text,
                    html: true
                }),
                Boolean(buttonTitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: "mt-16",
                    title: buttonTitle,
                    size: 48,
                    style: buttonStyle,
                    tabIndex: -1,
                    width: 240
                }),
                Boolean(caption) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                    className: "visually-hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        value: caption
                    })
                })
            ]
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BannerBase);


/***/ }),

/***/ 12769:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HeaderBannerContainer_HeaderBannerContainer)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/components/inputs/ButtonBase/ButtonBase.tsx
var ButtonBase = __webpack_require__(97127);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HeaderBannerContainer_module = ({"root":"DB633S"});
;// CONCATENATED MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx







const heightClassMap = {
    48: "h-48",
    56: "h-56",
    64: "h-64"
};
const HeaderBannerContainer = (props)=>{
    const { children, className, to, height, loading, trackParams, onClick, "data-testid": dataTestId } = props;
    const rootClassName = (0,clsx/* default */.Z)(className, HeaderBannerContainer_module.root, "flex items-center justify-center text-white", heightClassMap[height]);
    const content = loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "32/loader"
    }) : children;
    if (to || onClick) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
            className: (0,clsx/* default */.Z)(rootClassName, "w-full"),
            to: to,
            role: "complementary",
            loading: loading,
            onClick: ()=>{
                (0,analytics/* track */.j)("Banner click", trackParams);
                if (typeof onClick === "function") {
                    onClick();
                }
            },
            "data-testid": dataTestId,
            children: content
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-testid": dataTestId,
        role: "complementary",
        children: content
    });
};
/* harmony default export */ const HeaderBannerContainer_HeaderBannerContainer = (HeaderBannerContainer);


/***/ }),

/***/ 64792:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscribeHeaderBanner_SubscribeHeaderBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(70104);
// EXTERNAL MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/SubscribeHeaderBannerBase.tsx + 3 modules
var SubscribeHeaderBannerBase = __webpack_require__(60423);
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBanner/messages.ts
/* harmony default export */ const messages = ({
    discount: {
        mobile: {
            en: "Get {discount} off your first month"
        },
        desktop: {
            en: "Get {discount} off your first month of Scentbird"
        }
    },
    freeTrial: {
        mobile: {
            en: "Get your free perfume now"
        },
        desktop: {
            en: "Get your free perfume now. Your first month is free, just pay {extraShippingPrice} for shipping and handling"
        }
    },
    freeProduct: {
        mobile: {
            en: "Subscribe and unlock your free product"
        },
        desktop: {
            en: "Subscribe and unlock a free product in your first order"
        }
    },
    freeMonth: {
        mobile: {
            en: "Unlock your second month for free"
        },
        desktop: {
            en: "Buy one, get one free! Monthly supply of any listed fragrance starting at {price}"
        }
    },
    noDiscountText: {
        en: "Get your first month of Scentbird for {price}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBanner/SubscribeHeaderBanner.tsx







const textByOffer = {
    freeTrial: messages.freeTrial,
    free2ndMonth: messages.freeMonth,
    freeProduct: messages.freeProduct,
    discount: messages.discount
};
const SubscribeHeaderBanner = (props)=>{
    var _textByOffer_offerType;
    const { placement = "Header", withCountdown, withArrow = true, countdownCookieName } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { isFetching, discountText, eventDiscountText, couponCode, formattedPrice, formattedExtraShippingPrice, offerType, handleSubscribeClick } = (0,subscribe/* useSubscribeOffer */.Hu)();
    const deviceType = isMobile ? "mobile" : "desktop";
    const title = {
        ...((_textByOffer_offerType = textByOffer[offerType]) === null || _textByOffer_offerType === void 0 ? void 0 : _textByOffer_offerType[deviceType]) || messages.noDiscountText,
        values: {
            discount: discountText,
            price: formattedPrice,
            extraShippingPrice: formattedExtraShippingPrice
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeHeaderBannerBase/* default */.Z, {
        title: title,
        loading: isFetching,
        withArrow: withArrow,
        withCountdown: withCountdown,
        countdownCookieName: countdownCookieName,
        trackParams: {
            placement,
            content: "Subscribe",
            action: "link",
            link: links/* default */.ZP.subscribe,
            discount: eventDiscountText,
            coupon: couponCode
        },
        onClick: handleSubscribeClick
    });
};
/* harmony default export */ const SubscribeHeaderBanner_SubscribeHeaderBanner = (SubscribeHeaderBanner);


/***/ }),

/***/ 60423:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscribeHeaderBannerBase_SubscribeHeaderBannerBase)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(927);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx + 1 modules
var HeaderBannerContainer = __webpack_require__(12769);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(17164);
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/messages.ts
/* harmony default export */ const messages = ({
    start: {
        en: "Offer ends in"
    },
    time: {
        en: "{time}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/Countdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Countdown_module = ({"seconds":"Mngfsm","milliseconds":"DIFWZO"});
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/Countdown.tsx







const secondsFormat = "mm [min], ss [sec]";
const millisecondsFormat = "mm [min], ss.S [sec]";
const Countdown = (param)=>{
    let { cookieName, withMilliseconds = true } = param;
    const countdownRef = (0,react.useRef)();
    const { countdownMessage, isExpired } = (0,useCountdown/* default */.Z)({
        nodeRef: countdownRef,
        cookieName,
        initialTime: 20 * 60 * 1000,
        format: withMilliseconds ? millisecondsFormat : secondsFormat,
        withMilliseconds,
        message: messages.time
    });
    if (isExpired) {
        return null;
    }
    const timeClassName = (0,clsx/* default */.Z)("inline-block", withMilliseconds ? Countdown_module.milliseconds : Countdown_module.seconds, withMilliseconds ? "text-black" : null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ". ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "inline-block whitespace-nowrap text-left",
                "data-testid": "timer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: messages.start
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        ref: countdownRef,
                        className: timeClassName,
                        children: countdownMessage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const Countdown_Countdown = (Countdown);

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/SubscribeHeaderBannerBase.tsx








// base banner without any logic about offer copy and countdown
const SubscribeHeaderBannerBase = (props)=>{
    const { title, to = links/* default */.ZP.subscribe, trackParams, loading, onClick, isStatic, withArrow, withCountdown, withMilliseconds, countdownCookieName } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const bannerProps = {
        className: "bg-gold-50",
        height: isMobile ? 48 : 64,
        "data-testid": "subscribeBanner",
        loading
    };
    if (!isStatic) {
        bannerProps.to = to;
        bannerProps.trackParams = trackParams;
        bannerProps.onClick = onClick;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBannerContainer/* default */.Z, {
        ...bannerProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                style: isMobile ? "sh6" : "sh5",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "whitespace-nowrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                            value: title
                        })
                    }),
                    withCountdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown_Countdown, {
                        cookieName: countdownCookieName,
                        withMilliseconds: withMilliseconds
                    })
                ]
            }),
            withArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "ml-12 flex-none",
                name: "other/long-arrow-right"
            })
        ]
    });
};
/* harmony default export */ const SubscribeHeaderBannerBase_SubscribeHeaderBannerBase = (SubscribeHeaderBannerBase);


/***/ }),

/***/ 68937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ TheEditBanner_TheEditBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(80550);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/modules/messages/messages.ts
var messages = __webpack_require__(35000);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var Button_messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/compositions/banners/BannerBase/BannerBase.tsx
var BannerBase = __webpack_require__(61835);
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/images/bg.jpg
const bg_namespaceObject = __webpack_require__.p + "images/bg_cbfdf7.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/images/bg-ab.png
const bg_ab_namespaceObject = __webpack_require__.p + "images/bg-ab_02bc8b.png";
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/messages.ts
/* harmony default export */ const TheEditBanner_messages = ({
    title: {
        en: "Shop the Edit"
    },
    text: {
        en: `
      Immerse yourself in scent<br />
      beyond the bottle with<br />
      candles, body lotions,<br />
      diffusers, and so much more.
    `
    },
    valentinesText: {
        en: "Find your loves among our <br />selection of gift sets, candles, body <br />care products, and more."
    },
    luxeText: {
        en: "From scented candles to body care <br />products, these products are big on <br />luxury, but easy on your wallet."
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/TheEditBanner.tsx












const TheEditBanner = (props)=>{
    const { onClick, "data-testid": dataTestId = "theEditBanner", placement } = props;
    const isTheValentinesEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theValentinesEdit) === "b";
    const isTheLuxeEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theLuxeEdit) === "b";
    let bannerBaseProps;
    if (isTheValentinesEditEnabled) {
        bannerBaseProps = {
            title: messages/* default */.Z.theValentinesEdit,
            text: TheEditBanner_messages.valentinesText,
            bgImage: bg_ab_namespaceObject,
            buttonTitle: Button_messages/* default */.Z.shopNow
        };
    } else if (isTheLuxeEditEnabled) {
        bannerBaseProps = {
            title: messages/* default */.Z.theLuxeEdit,
            text: TheEditBanner_messages.luxeText,
            bgImage: bg_ab_namespaceObject,
            buttonTitle: Button_messages/* default */.Z.shopNow
        };
    } else {
        bannerBaseProps = {
            title: TheEditBanner_messages.title,
            text: TheEditBanner_messages.text,
            bgImage: bg_namespaceObject,
            buttonTitle: Button_messages/* default */.Z.learnMore
        };
    }
    (0,react.useEffect)(()=>{
        if (isTheValentinesEditEnabled || isTheLuxeEditEnabled) {
            (0,analytics/* track */.j)("The Edit entry point display");
        }
    }, [
        isTheValentinesEditEnabled,
        isTheLuxeEditEnabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.shop.theEdit,
        textColor: "black",
        content: "TheEdit",
        onClick: onClick,
        placement: placement,
        "data-testid": dataTestId,
        ...bannerBaseProps
    });
};
/* harmony default export */ const TheEditBanner_TheEditBanner = (TheEditBanner);


/***/ }),

/***/ 84211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39977);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95812);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64881);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30468);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34212);






const ResubscribeButton = (props)=>{
    const { className, size = 56, style = "primary", width, fullWidth, fullWidthOnMobile, productToAdd, title, loading, placement, onProductAdded, "data-testid": dataTestId = "resubscribeButton" } = props;
    const { eventOffer } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useResubscribeOffer */ .W)();
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        (0,analytics__WEBPACK_IMPORTED_MODULE_3__/* .track */ .j)("Banner click", {
            placement,
            content: "Resubscribe",
            offer: eventOffer
        });
        (0,modals__WEBPACK_IMPORTED_MODULE_4__/* .openModal */ .h7)("resubscribeModal", {
            productToAdd,
            onProductAdded
        });
    }, [
        placement,
        eventOffer,
        productToAdd,
        onProductAdded
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: className,
        title: title || components_inputs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.resubscribeNow,
        size: size,
        style: style,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        "data-testid": dataTestId,
        onClick: handleClick,
        loading: loading,
        // TODO: Improve the flow by making sure that this property is used only within the product description — added on 12–02–2024 by algeas
        "data-cnstrc-btn": "resubscribe",
        html: true
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ResubscribeButton));


/***/ }),

/***/ 20308:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const NavList = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const { children, className, listClassName, "aria-label": ariaLabel } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: className,
        ref: ref,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            className: listClassName,
            children: children
        })
    });
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NavList);


/***/ }),

/***/ 21864:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  J: () => (/* binding */ Ct)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(63730);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(58141);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(95701);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/micro-task.js
var micro_task = __webpack_require__(96376);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-on-unmount.js
function c(t){let r=(0,use_event/* useEvent */.z)(t),e=(0,react.useRef)(!1);(0,react.useEffect)(()=>(e.current=!1,()=>{e.current=!0,(0,micro_task/* microTask */.Y)(()=>{e.current&&r()})}),[r])}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-owner.js
var use_owner = __webpack_require__(71789);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var use_server_handoff_complete = __webpack_require__(59896);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(31596);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/internal/portal-force-root.js
let e=(0,react.createContext)(!1);function portal_force_root_a(){return (0,react.useContext)(e)}function l(o){return t.createElement(e.Provider,{value:o.force},o.children)}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/env.js
var env = __webpack_require__(86283);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/render.js + 1 modules
var render = __webpack_require__(15386);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/portal/portal.js
function F(p){let n=portal_force_root_a(),l=(0,react.useContext)(_),e=(0,use_owner/* useOwnerDocument */.i)(p),[a,o]=(0,react.useState)(()=>{if(!n&&l!==null||env/* env */.O.isServer)return null;let t=e==null?void 0:e.getElementById("headlessui-portal-root");if(t)return t;if(e===null)return null;let r=e.createElement("div");return r.setAttribute("id","headlessui-portal-root"),e.body.appendChild(r)});return (0,react.useEffect)(()=>{a!==null&&(e!=null&&e.body.contains(a)||e==null||e.body.appendChild(a))},[a,e]),(0,react.useEffect)(()=>{n||l!==null&&o(l.current)},[l,o,n]),a}let U=react.Fragment;function N(p,n){let l=p,e=(0,react.useRef)(null),a=(0,use_sync_refs/* useSyncRefs */.T)((0,use_sync_refs/* optionalRef */.h)(u=>{e.current=u}),n),o=(0,use_owner/* useOwnerDocument */.i)(e),t=F(e),[r]=(0,react.useState)(()=>{var u;return env/* env */.O.isServer?null:(u=o==null?void 0:o.createElement("div"))!=null?u:null}),i=(0,react.useContext)(f),v=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{!t||!r||t.contains(r)||(r.setAttribute("data-headlessui-portal",""),t.appendChild(r))},[t,r]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(r&&i)return i.register(r)},[i,r]),c(()=>{var u;!t||!r||(r instanceof Node&&t.contains(r)&&t.removeChild(r),t.childNodes.length<=0&&((u=t.parentElement)==null||u.removeChild(t)))}),v?!t||!r?null:(0,react_dom.createPortal)((0,render/* render */.sY)({ourProps:{ref:a},theirProps:l,defaultTag:U,name:"Portal"}),r):null}let S=react.Fragment,_=(0,react.createContext)(null);function j(p,n){let{target:l,...e}=p,o={ref:(0,use_sync_refs/* useSyncRefs */.T)(n)};return react.createElement(_.Provider,{value:l},(0,render/* render */.sY)({ourProps:o,theirProps:e,defaultTag:S,name:"Popover.Group"}))}let f=(0,react.createContext)(null);function ee(){let p=(0,react.useContext)(f),n=(0,react.useRef)([]),l=(0,use_event/* useEvent */.z)(o=>(n.current.push(o),p&&p.register(o),()=>e(o))),e=(0,use_event/* useEvent */.z)(o=>{let t=n.current.indexOf(o);t!==-1&&n.current.splice(t,1),p&&p.unregister(o)}),a=(0,react.useMemo)(()=>({register:l,unregister:e,portals:n}),[l,e,n]);return[n,(0,react.useMemo)(()=>function({children:t}){return react.createElement(f.Provider,{value:a},t)},[a])]}let D=(0,render/* forwardRefWithAs */.yV)(N),I=(0,render/* forwardRefWithAs */.yV)(j),te=Object.assign(D,{Group:I});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(73910);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-event-listener.js
function use_event_listener_E(n,e,a,t){let i=(0,use_latest_value/* useLatestValue */.E)(a);(0,react.useEffect)(()=>{n=n!=null?n:window;function r(o){i.current(o)}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t])}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(93788);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-outside-click.js + 1 modules
var use_outside_click = __webpack_require__(90566);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(35751);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(66769);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-root-containers.js
function use_root_containers_N({defaultContainers:o=[],portals:r,mainTreeNodeRef:u}={}){var f;let t=(0,react.useRef)((f=u==null?void 0:u.current)!=null?f:null),l=(0,use_owner/* useOwnerDocument */.i)(t),c=(0,use_event/* useEvent */.z)(()=>{var i,s,a;let n=[];for(let e of o)e!==null&&(e instanceof HTMLElement?n.push(e):"current"in e&&e.current instanceof HTMLElement&&n.push(e.current));if(r!=null&&r.current)for(let e of r.current)n.push(e);for(let e of(i=l==null?void 0:l.querySelectorAll("html > *, body > *"))!=null?i:[])e!==document.body&&e!==document.head&&e instanceof HTMLElement&&e.id!=="headlessui-portal-root"&&(e.contains(t.current)||e.contains((a=(s=t.current)==null?void 0:s.getRootNode())==null?void 0:a.host)||n.some(L=>e.contains(L))||n.push(e));return n});return{resolveContainers:c,contains:(0,use_event/* useEvent */.z)(n=>c().some(i=>i.contains(n))),mainTreeNodeRef:t,MainTreeNode:(0,react.useMemo)(()=>function(){return u!=null?null:react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features */.A.Hidden,ref:t})},[t,u])}}function use_root_containers_y(){let o=(0,react.useRef)(null);return{mainTreeNodeRef:o,MainTreeNode:(0,react.useMemo)(()=>function(){return react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features */.A.Hidden,ref:o})},[o])}}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-window-event.js
var use_window_event = __webpack_require__(99145);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var use_tab_direction_s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(use_tab_direction_s||{});function use_tab_direction_n(){let e=(0,react.useRef)(0);return (0,use_window_event/* useWindowEvent */.s)("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0)},!0),e}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(58590);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(65579);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(91858);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(94228);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(3638);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(38656);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/popover/popover.js
var he=(u=>(u[u.Open=0]="Open",u[u.Closed=1]="Closed",u))(he||{}),He=(e=>(e[e.TogglePopover=0]="TogglePopover",e[e.ClosePopover=1]="ClosePopover",e[e.SetButton=2]="SetButton",e[e.SetButtonId=3]="SetButtonId",e[e.SetPanel=4]="SetPanel",e[e.SetPanelId=5]="SetPanelId",e))(He||{});let Ge={[0]:t=>{let o={...t,popoverState:(0,match/* match */.E)(t.popoverState,{[0]:1,[1]:0})};return o.popoverState===0&&(o.__demoMode=!1),o},[1](t){return t.popoverState===1?t:{...t,popoverState:1}},[2](t,o){return t.button===o.button?t:{...t,button:o.button}},[3](t,o){return t.buttonId===o.buttonId?t:{...t,buttonId:o.buttonId}},[4](t,o){return t.panel===o.panel?t:{...t,panel:o.panel}},[5](t,o){return t.panelId===o.panelId?t:{...t,panelId:o.panelId}}},ue=(0,react.createContext)(null);ue.displayName="PopoverContext";function oe(t){let o=(0,react.useContext)(ue);if(o===null){let u=new Error(`<${t} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(u,oe),u}return o}let ie=(0,react.createContext)(null);ie.displayName="PopoverAPIContext";function fe(t){let o=(0,react.useContext)(ie);if(o===null){let u=new Error(`<${t} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(u,fe),u}return o}let Pe=(0,react.createContext)(null);Pe.displayName="PopoverGroupContext";function Ee(){return (0,react.useContext)(Pe)}let re=(0,react.createContext)(null);re.displayName="PopoverPanelContext";function Ne(){return (0,react.useContext)(re)}function ke(t,o){return (0,match/* match */.E)(o.type,Ge,t,o)}let we="div";function Ue(t,o){var B;let{__demoMode:u=!1,...M}=t,x=(0,react.useRef)(null),n=(0,use_sync_refs/* useSyncRefs */.T)(o,(0,use_sync_refs/* optionalRef */.h)(l=>{x.current=l})),e=(0,react.useRef)([]),c=(0,react.useReducer)(ke,{__demoMode:u,popoverState:u?0:1,buttons:e,button:null,buttonId:null,panel:null,panelId:null,beforePanelSentinel:(0,react.createRef)(),afterPanelSentinel:(0,react.createRef)()}),[{popoverState:f,button:s,buttonId:I,panel:a,panelId:v,beforePanelSentinel:y,afterPanelSentinel:A},P]=c,p=(0,use_owner/* useOwnerDocument */.i)((B=x.current)!=null?B:s),E=(0,react.useMemo)(()=>{if(!s||!a)return!1;for(let W of document.querySelectorAll("body > *"))if(Number(W==null?void 0:W.contains(s))^Number(W==null?void 0:W.contains(a)))return!0;let l=(0,focus_management/* getFocusableElements */.GO)(),S=l.indexOf(s),q=(S+l.length-1)%l.length,U=(S+1)%l.length,z=l[q],be=l[U];return!a.contains(z)&&!a.contains(be)},[s,a]),F=(0,use_latest_value/* useLatestValue */.E)(I),D=(0,use_latest_value/* useLatestValue */.E)(v),_=(0,react.useMemo)(()=>({buttonId:F,panelId:D,close:()=>P({type:1})}),[F,D,P]),O=Ee(),L=O==null?void 0:O.registerPopover,$=(0,use_event/* useEvent */.z)(()=>{var l;return(l=O==null?void 0:O.isFocusWithinPopoverGroup())!=null?l:(p==null?void 0:p.activeElement)&&((s==null?void 0:s.contains(p.activeElement))||(a==null?void 0:a.contains(p.activeElement)))});(0,react.useEffect)(()=>L==null?void 0:L(_),[L,_]);let[i,b]=ee(),T=use_root_containers_N({mainTreeNodeRef:O==null?void 0:O.mainTreeNodeRef,portals:i,defaultContainers:[s,a]});use_event_listener_E(p==null?void 0:p.defaultView,"focus",l=>{var S,q,U,z;l.target!==window&&l.target instanceof HTMLElement&&f===0&&($()||s&&a&&(T.contains(l.target)||(q=(S=y.current)==null?void 0:S.contains)!=null&&q.call(S,l.target)||(z=(U=A.current)==null?void 0:U.contains)!=null&&z.call(U,l.target)||P({type:1})))},!0),(0,use_outside_click/* useOutsideClick */.O)(T.resolveContainers,(l,S)=>{P({type:1}),(0,focus_management/* isFocusableElement */.sP)(S,focus_management/* FocusableMode */.tJ.Loose)||(l.preventDefault(),s==null||s.focus())},f===0);let d=(0,use_event/* useEvent */.z)(l=>{P({type:1});let S=(()=>l?l instanceof HTMLElement?l:"current"in l&&l.current instanceof HTMLElement?l.current:s:s)();S==null||S.focus()}),r=(0,react.useMemo)(()=>({close:d,isPortalled:E}),[d,E]),m=(0,react.useMemo)(()=>({open:f===0,close:d}),[f,d]),g={ref:n};return react.createElement(re.Provider,{value:null},react.createElement(ue.Provider,{value:c},react.createElement(ie.Provider,{value:r},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(f,{[0]:open_closed/* State */.ZM.Open,[1]:open_closed/* State */.ZM.Closed})},react.createElement(b,null,(0,render/* render */.sY)({ourProps:g,theirProps:M,slot:m,defaultTag:we,name:"Popover"}),react.createElement(T.MainTreeNode,null))))))}let We="button";function Ke(t,o){let u=(0,use_id/* useId */.M)(),{id:M=`headlessui-popover-button-${u}`,...x}=t,[n,e]=oe("Popover.Button"),{isPortalled:c}=fe("Popover.Button"),f=(0,react.useRef)(null),s=`headlessui-focus-sentinel-${(0,use_id/* useId */.M)()}`,I=Ee(),a=I==null?void 0:I.closeOthers,y=Ne()!==null;(0,react.useEffect)(()=>{if(!y)return e({type:3,buttonId:M}),()=>{e({type:3,buttonId:null})}},[y,M,e]);let[A]=(0,react.useState)(()=>Symbol()),P=(0,use_sync_refs/* useSyncRefs */.T)(f,o,y?null:r=>{if(r)n.buttons.current.push(A);else{let m=n.buttons.current.indexOf(A);m!==-1&&n.buttons.current.splice(m,1)}n.buttons.current.length>1&&console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."),r&&e({type:2,button:r})}),p=(0,use_sync_refs/* useSyncRefs */.T)(f,o),E=(0,use_owner/* useOwnerDocument */.i)(f),F=(0,use_event/* useEvent */.z)(r=>{var m,g,B;if(y){if(n.popoverState===1)return;switch(r.key){case keyboard/* Keys */.R.Space:case keyboard/* Keys */.R.Enter:r.preventDefault(),(g=(m=r.target).click)==null||g.call(m),e({type:1}),(B=n.button)==null||B.focus();break}}else switch(r.key){case keyboard/* Keys */.R.Space:case keyboard/* Keys */.R.Enter:r.preventDefault(),r.stopPropagation(),n.popoverState===1&&(a==null||a(n.buttonId)),e({type:0});break;case keyboard/* Keys */.R.Escape:if(n.popoverState!==0)return a==null?void 0:a(n.buttonId);if(!f.current||E!=null&&E.activeElement&&!f.current.contains(E.activeElement))return;r.preventDefault(),r.stopPropagation(),e({type:1});break}}),D=(0,use_event/* useEvent */.z)(r=>{y||r.key===keyboard/* Keys */.R.Space&&r.preventDefault()}),_=(0,use_event/* useEvent */.z)(r=>{var m,g;(0,bugs/* isDisabledReactIssue7711 */.P)(r.currentTarget)||t.disabled||(y?(e({type:1}),(m=n.button)==null||m.focus()):(r.preventDefault(),r.stopPropagation(),n.popoverState===1&&(a==null||a(n.buttonId)),e({type:0}),(g=n.button)==null||g.focus()))}),O=(0,use_event/* useEvent */.z)(r=>{r.preventDefault(),r.stopPropagation()}),L=n.popoverState===0,$=(0,react.useMemo)(()=>({open:L}),[L]),i=(0,use_resolve_button_type/* useResolveButtonType */.f)(t,f),b=y?{ref:p,type:i,onKeyDown:F,onClick:_}:{ref:P,id:n.buttonId,type:i,"aria-expanded":n.popoverState===0,"aria-controls":n.panel?n.panelId:void 0,onKeyDown:F,onKeyUp:D,onClick:_,onMouseDown:O},T=use_tab_direction_n(),d=(0,use_event/* useEvent */.z)(()=>{let r=n.panel;if(!r)return;function m(){(0,match/* match */.E)(T.current,{[use_tab_direction_s.Forwards]:()=>(0,focus_management/* focusIn */.jA)(r,focus_management/* Focus */.TO.First),[use_tab_direction_s.Backwards]:()=>(0,focus_management/* focusIn */.jA)(r,focus_management/* Focus */.TO.Last)})===focus_management/* FocusResult */.fE.Error&&(0,focus_management/* focusIn */.jA)((0,focus_management/* getFocusableElements */.GO)().filter(B=>B.dataset.headlessuiFocusGuard!=="true"),(0,match/* match */.E)(T.current,{[use_tab_direction_s.Forwards]:focus_management/* Focus */.TO.Next,[use_tab_direction_s.Backwards]:focus_management/* Focus */.TO.Previous}),{relativeTo:n.button})}m()});return react.createElement(react.Fragment,null,(0,render/* render */.sY)({ourProps:b,theirProps:x,slot:$,defaultTag:We,name:"Popover.Button"}),L&&!y&&c&&react.createElement(internal_hidden/* Hidden */._,{id:s,features:internal_hidden/* Features */.A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:d}))}let je="div",Ve=render/* Features */.AN.RenderStrategy|render/* Features */.AN.Static;function $e(t,o){let u=(0,use_id/* useId */.M)(),{id:M=`headlessui-popover-overlay-${u}`,...x}=t,[{popoverState:n},e]=oe("Popover.Overlay"),c=(0,use_sync_refs/* useSyncRefs */.T)(o),f=(0,open_closed/* useOpenClosed */.oJ)(),s=(()=>f!==null?(f&open_closed/* State */.ZM.Open)===open_closed/* State */.ZM.Open:n===0)(),I=(0,use_event/* useEvent */.z)(y=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(y.currentTarget))return y.preventDefault();e({type:1})}),a=(0,react.useMemo)(()=>({open:n===0}),[n]);return (0,render/* render */.sY)({ourProps:{ref:c,id:M,"aria-hidden":!0,onClick:I},theirProps:x,slot:a,defaultTag:je,features:Ve,visible:s,name:"Popover.Overlay"})}let Je="div",Xe=render/* Features */.AN.RenderStrategy|render/* Features */.AN.Static;function Ye(t,o){let u=(0,use_id/* useId */.M)(),{id:M=`headlessui-popover-panel-${u}`,focus:x=!1,...n}=t,[e,c]=oe("Popover.Panel"),{close:f,isPortalled:s}=fe("Popover.Panel"),I=`headlessui-focus-sentinel-before-${(0,use_id/* useId */.M)()}`,a=`headlessui-focus-sentinel-after-${(0,use_id/* useId */.M)()}`,v=(0,react.useRef)(null),y=(0,use_sync_refs/* useSyncRefs */.T)(v,o,i=>{c({type:4,panel:i})}),A=(0,use_owner/* useOwnerDocument */.i)(v),P=(0,render/* useMergeRefsFn */.Y2)();(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>(c({type:5,panelId:M}),()=>{c({type:5,panelId:null})}),[M,c]);let p=(0,open_closed/* useOpenClosed */.oJ)(),E=(()=>p!==null?(p&open_closed/* State */.ZM.Open)===open_closed/* State */.ZM.Open:e.popoverState===0)(),F=(0,use_event/* useEvent */.z)(i=>{var b;switch(i.key){case keyboard/* Keys */.R.Escape:if(e.popoverState!==0||!v.current||A!=null&&A.activeElement&&!v.current.contains(A.activeElement))return;i.preventDefault(),i.stopPropagation(),c({type:1}),(b=e.button)==null||b.focus();break}});(0,react.useEffect)(()=>{var i;t.static||e.popoverState===1&&((i=t.unmount)==null||i)&&c({type:4,panel:null})},[e.popoverState,t.unmount,t.static,c]),(0,react.useEffect)(()=>{if(e.__demoMode||!x||e.popoverState!==0||!v.current)return;let i=A==null?void 0:A.activeElement;v.current.contains(i)||(0,focus_management/* focusIn */.jA)(v.current,focus_management/* Focus */.TO.First)},[e.__demoMode,x,v,e.popoverState]);let D=(0,react.useMemo)(()=>({open:e.popoverState===0,close:f}),[e,f]),_={ref:y,id:M,onKeyDown:F,onBlur:x&&e.popoverState===0?i=>{var T,d,r,m,g;let b=i.relatedTarget;b&&v.current&&((T=v.current)!=null&&T.contains(b)||(c({type:1}),((r=(d=e.beforePanelSentinel.current)==null?void 0:d.contains)!=null&&r.call(d,b)||(g=(m=e.afterPanelSentinel.current)==null?void 0:m.contains)!=null&&g.call(m,b))&&b.focus({preventScroll:!0})))}:void 0,tabIndex:-1},O=use_tab_direction_n(),L=(0,use_event/* useEvent */.z)(()=>{let i=v.current;if(!i)return;function b(){(0,match/* match */.E)(O.current,{[use_tab_direction_s.Forwards]:()=>{var d;(0,focus_management/* focusIn */.jA)(i,focus_management/* Focus */.TO.First)===focus_management/* FocusResult */.fE.Error&&((d=e.afterPanelSentinel.current)==null||d.focus())},[use_tab_direction_s.Backwards]:()=>{var T;(T=e.button)==null||T.focus({preventScroll:!0})}})}b()}),$=(0,use_event/* useEvent */.z)(()=>{let i=v.current;if(!i)return;function b(){(0,match/* match */.E)(O.current,{[use_tab_direction_s.Forwards]:()=>{var B;if(!e.button)return;let T=(0,focus_management/* getFocusableElements */.GO)(),d=T.indexOf(e.button),r=T.slice(0,d+1),g=[...T.slice(d+1),...r];for(let l of g.slice())if(l.dataset.headlessuiFocusGuard==="true"||(B=e.panel)!=null&&B.contains(l)){let S=g.indexOf(l);S!==-1&&g.splice(S,1)}(0,focus_management/* focusIn */.jA)(g,focus_management/* Focus */.TO.First,{sorted:!1})},[use_tab_direction_s.Backwards]:()=>{var d;(0,focus_management/* focusIn */.jA)(i,focus_management/* Focus */.TO.Previous)===focus_management/* FocusResult */.fE.Error&&((d=e.button)==null||d.focus())}})}b()});return react.createElement(re.Provider,{value:M},E&&s&&react.createElement(internal_hidden/* Hidden */._,{id:I,ref:e.beforePanelSentinel,features:internal_hidden/* Features */.A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:L}),(0,render/* render */.sY)({mergeRefs:P,ourProps:_,theirProps:n,slot:D,defaultTag:Je,features:Xe,visible:E,name:"Popover.Panel"}),E&&s&&react.createElement(internal_hidden/* Hidden */._,{id:a,ref:e.afterPanelSentinel,features:internal_hidden/* Features */.A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:$}))}let qe="div";function ze(t,o){let u=(0,react.useRef)(null),M=(0,use_sync_refs/* useSyncRefs */.T)(u,o),[x,n]=(0,react.useState)([]),e=use_root_containers_y(),c=(0,use_event/* useEvent */.z)(P=>{n(p=>{let E=p.indexOf(P);if(E!==-1){let F=p.slice();return F.splice(E,1),F}return p})}),f=(0,use_event/* useEvent */.z)(P=>(n(p=>[...p,P]),()=>c(P))),s=(0,use_event/* useEvent */.z)(()=>{var E;let P=(0,owner/* getOwnerDocument */.r)(u);if(!P)return!1;let p=P.activeElement;return(E=u.current)!=null&&E.contains(p)?!0:x.some(F=>{var D,_;return((D=P.getElementById(F.buttonId.current))==null?void 0:D.contains(p))||((_=P.getElementById(F.panelId.current))==null?void 0:_.contains(p))})}),I=(0,use_event/* useEvent */.z)(P=>{for(let p of x)p.buttonId.current!==P&&p.close()}),a=(0,react.useMemo)(()=>({registerPopover:f,unregisterPopover:c,isFocusWithinPopoverGroup:s,closeOthers:I,mainTreeNodeRef:e.mainTreeNodeRef}),[f,c,s,I,e.mainTreeNodeRef]),v=(0,react.useMemo)(()=>({}),[]),y=t,A={ref:M};return react.createElement(Pe.Provider,{value:a},(0,render/* render */.sY)({ourProps:A,theirProps:y,slot:v,defaultTag:qe,name:"Popover.Group"}),react.createElement(e.MainTreeNode,null))}let Qe=(0,render/* forwardRefWithAs */.yV)(Ue),Ze=(0,render/* forwardRefWithAs */.yV)(Ke),et=(0,render/* forwardRefWithAs */.yV)($e),tt=(0,render/* forwardRefWithAs */.yV)(Ye),ot=(0,render/* forwardRefWithAs */.yV)(ze),Ct=Object.assign(Qe,{Button:Ze,Overlay:et,Panel:tt,Group:ot});


/***/ })

}]);